const removeUnnecessaryParenthesis = (composition: string) =>
  composition.replaceAll(/\((\d*)\)/g, '$1')

export default function removeGroupFromComposition(
  groupToRemove: number,
  composition: string
) {
  const compositionWithoutRemovedGroup = removeUnnecessaryParenthesis(
    composition
  ).replaceAll(
    new RegExp(
      `((( AND | OR )${groupToRemove}\\b)|(\\b${groupToRemove}( AND | OR |\\b)))`,
      'g'
    ),
    ''
  )

  const compositionRenumbered = removeUnnecessaryParenthesis(
    compositionWithoutRemovedGroup
  ).replace(/\d+/g, (matchedNumber) => {
    if (Number(matchedNumber) > groupToRemove) {
      return String(Number(matchedNumber) - 1)
    }
    return matchedNumber
  })

  return compositionRenumbered
}
